import { useQuery } from '@tanstack/react-query';
import { getRespectForUser, getSpotlight } from '../services/api/respect';

export function useRespect(userId: number) {
  return useQuery({
    queryKey: ['respect', userId],
    queryFn: () => getRespectForUser(userId),
    enabled: Number.isFinite(userId),
  });
}

export function useSpotlight(limit = 5) {
  return useQuery({
    queryKey: ['respect', 'spotlight', limit],
    queryFn: () => getSpotlight(limit),
    staleTime: 5 * 60 * 1000,
  });
}
